
import React from 'react';
import Hdr from './shared/Hdr';
import { useState, useEffect, useRef } from 'react';
import swal from 'sweetalert';
//import { type } from '@testing-library/user-event/dist/type';
import Progress from './Progress';
import { apiPath, apiPath2 } from "../src/services/apiConfig";

function Doctors() {
  const user = localStorage.getItem('user-info');
  const token = localStorage.getItem('token');
  const usrRole = localStorage.getItem('user-role');
  const [displayDoctor, setDisplayDoctor] = useState('none');
  const [displayUpdDoctor, setDisplayUpdDoctor] = useState('none');
  const [data, setData] = useState([]);
  const [dataStat, setDataStat] = useState();
  const [specialityDataStat, setSpecialityDataStat] = useState('')
  const [specialityData, setSpecialityData] = useState([])
  const [departmentDataStat, setDepartmentDataStat] = useState('')
  const [departmentData, setDepartmentData] = useState([])
  const [doctorName, setDoctorName] = useState('');
  const [doctorRegno, setDoctorRegno] = useState('NA');
  const [doctorQualification, setDoctorQualification] = useState('');
  const [doctorSpeciality, setDoctorSpeciality] = useState('');
  const [doctorExperience, setDoctorExperience] = useState('0');
  //  const [id, setUID] = useState('');
  const [doctorFees, setDoctorFees] = useState('0');
  const [doctorGender, setDoctorGender] = useState('');
  const [doctorDepartment, setDoctorDepartment] = useState(0);
  const [doctorSpecialisation, setDoctorSpecialisation] = useState(0);
  const [verfied, setVerfied] = useState(false);
  const [updDoctorName, setDoctorUpdName] = useState('');
  const [updDoctorRegno, setDoctorUpdRegno] = useState('');
  const [updDoctorQualification, setDoctorUpdQualification] = useState('');
  const [updDoctorSpeciality, setDoctorUpdSpeciality] = useState('');
  const [updDoctorExperience, setDoctorUpdExperience] = useState('');
  const [updDoctorFees, setDoctorUpdFees] = useState('');
  const [updDoctorDepartment, setDoctorUpdDepartment] = useState('');
  const [updDoctorSpecialisation, setDoctorUpdSpecialisation] = useState('');
  const [updDoctorGender, setDoctorUpdGender] = useState('');
  const [uid, setUpdID] = useState('');
  const [IsDisabled, setIsDisabled] = useState(false)
  const [isloading, setIsLoading] = useState(false)
  const handleSubmit = () => {
    verifyDoctor()
    if (verfied) {
      formRef.current.reset();
    }
  }
  // const [uidErr, setUIDErr] = useState('');
  const formRef = useRef();
  // const [Err, SetErr] = useState([]);

  let txt = "";

  useEffect(() => {
    getDoctor()
    getSpeciality(1)
    getDepartment()
  }, [])

  function openDoctor() {
    setDisplayDoctor('block')
  }

  function closeDoctor() {
    formRef.current.reset();
    setDisplayDoctor('none')
  }

  function openUpdDoctor() {
    setDisplayUpdDoctor('block')
  }

  function closeUpdDoctor() {
    setDisplayUpdDoctor('none')
  }

  async function updateDoctor(id) {

    setIsLoading(true)

    let result = await fetch(apiPath + "doctors/" + id, {
      method: 'PUT',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({
        "name": updDoctorName,
        "specialityId": updDoctorSpeciality,
        "departmentId": updDoctorDepartment,
        "reg_no": updDoctorRegno,
        "gender": updDoctorGender,
        "yrOfExperience": updDoctorExperience,
        "consultationFees": updDoctorFees,
        "qualification": updDoctorQualification,
        "specilation": updDoctorSpecialisation
      })
    });

    result = await result.json();

    showSwal(result.success, result.message)

    if (isloading) {
    } else {
      setIsLoading(false)
    }

    getDoctor()
  }

  async function deleteDoctor(id) {

    let result = await fetch(apiPath + "doctors/" + id, {
      method: 'DELETE',
      headers: {
        "Authorization": `Bearer ${token}`
      },
    });
    result = await result.json();

    showSwal(result.success, result.message)

    getDoctor()
  }



  async function updateOperation(id) {

    let result = await fetch(apiPath + "doctors/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",

          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },

      });

    result = await result.json();

    setDoctorUpdName(result.data.name);
    setDoctorUpdRegno(result.data.reg_no);
    setDoctorUpdQualification(result.data.qualification);
    setDoctorUpdSpecialisation(result.data.specialisation);
    setDoctorUpdExperience(result.data.yrOfExperience);
    setDoctorUpdFees(result.data.consultationFees);
    setDoctorUpdDepartment(result.data.departmentId);
    setDoctorUpdSpeciality(result.data.specialityId);
    setDoctorUpdGender(result.data.gender);
    setUpdID(result.data.doctorId)
    getSpeciality(result.data.departmentId)

    openUpdDoctor();
  }


  function deleteOperation(id) {

    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          deleteDoctor(id);
        }
        else {
          swal("Your record is safe!");
        }
      });
  }


  //* LIST OF ALL DOCTORS (for initial screen)*/ 

  async function getDoctor() {
    let result = await fetch(apiPath + "doctors",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      })

    result = await result.json();
    setDataStat(result.success);
    setData(result.data);
    if (result.success === true) {
      setData(result.data);
    } else { setData([]) }
  }

  {/*
  function uidHandler(e) {
    setUIDErr('');
    e.preventDefault()
    let item = e.target.value
    if (!item) {
      setUIDErr("required")
    } else {
//      setUID(item)
    }
  }
 */}

  function verifyDoctor() {
    // alert(doctorDepartment)
    if (doctorDepartment === '0' || doctorDepartment === 0) {
      showSwal(false, 'Select Department')
      setVerfied(false)
    } else {
      setVerfied(true)
      if (doctorSpeciality === '0' || doctorSpeciality === 0) {
        showSwal(false, 'Select Specialisation')
        setVerfied(false)
      } else {
        if (doctorRegno === '' || doctorRegno === null) {
          setDoctorRegno('NA')
        }
        if (doctorExperience === '' || doctorExperience === null) {
          setDoctorExperience('0')
        }
        if (doctorFees === '' || doctorFees === null) {
          setDoctorFees('0')
        }
        setVerfied(true)
      }
    }

    if (verfied === true) {
      addDoctor()
    }
  }

  //*ADD A NEW DOCTOR*/ 
  async function addDoctor() {

    //alert(doctorSpecilation+', '+doctorSpecilation+', '+verfied)
    if (verfied) {
      setIsDisabled(true)
      setIsLoading(true)
      console.log('api-call')
      let result = await fetch(apiPath + "doctors", {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          "name": doctorName,
          "specialityId": doctorSpeciality,
          "departmentId": doctorDepartment,
          "reg_no": doctorRegno,
          "gender": doctorGender,
          "yrOfExperience": doctorExperience,
          "consultationFees": doctorFees,
          "qualification": doctorQualification,
          "specialisation": doctorSpecialisation
        })

      });
      result = await result.json();
      //  console.warn(result)

      if (result.success) {
        showSwal(result.success, result.message)
        InitData()
      }
      else {
        showSwal(result.success, result.message + ": " + JSON.stringify(result.data))
      }
      setIsDisabled(false)

      if (isloading) {
      } else {
        setIsLoading(false)
      }

      getDoctor()
    }
  }


  function InitData() {

    setDoctorDepartment('0')
    setDoctorSpeciality('0')
    setIsDisabled(false)
  }

  {/* LIST OF ALL SPECIALITY (for combo)*/ }

  async function getSpeciality(id) {
    let result2 = await fetch(apiPath2 + "getSpecialityByDept/" + id,
      //    "specialities"
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      })

    result2 = await result2.json();
    setSpecialityDataStat(result2.success);
    //  setSpecialityData(result2.data);
    if (result2.success === true) {
      setSpecialityData(result2.data);
    } else { setSpecialityData([]) }
  }

  //* LIST OF ALL DEPARTMENT (for combo)*/ 

  async function getDepartment() {
    let result3 = await fetch(apiPath + "departments",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      })

    result3 = await result3.json();
    setDepartmentDataStat(result3.success);
    if (result3.success === true) {
      setDepartmentData(result3.data);
    } else { setDepartmentData([]) }
  }


  function showSwal(stat, txt) {
    if (stat === true) {
      swal({
        title: "Success!",
        text: txt,
        icon: "success",
        button: "OK!",
      });
    } else {
      swal({
        title: "Fail!",
        text: txt,
        icon: "error",
        button: "OK!",
      });
    }
  }

  function getDept(id) {
    setDoctorDepartment(id)
    getSpeciality(id)
  }


  function getUpdDept(id) {
    getSpeciality(id)
    setDoctorUpdDepartment(id)
  }

  return (

    <div style={{ 'height': '90vh' }}>
      <Hdr />
      <div className="row p16">
        <div className="c12-l-8">
          <h3 className="" >ADS Hospital - User : {user} </h3>
        </div>
        <div className="c12-l-4 pr32 ">
          <p className="medium right">User : ({usrRole})</p>
        </div>
      </div>

      <div className="row p16" style={{ 'height': '90%' }}>
        <div className=" c12-l-12 cont__content p4" style={{ 'height': '100%' }}>
          <div className="row p32">
            <div className="c12-l-3">
              <h4 className="wide">Doctors Management</h4>
            </div>
            <div className="c12-l-7"></div>
            <div className="c12-l-2">
              <button onClick={openDoctor} type="button" name="button"
                className="btn solid round">Create Doctor</button>
            </div>
          </div>

          <div className="row mt16" >
            <table style={{ 'height': '100%', 'width': '100%', 'overflowY': 'scroll', 'overflowX': 'scroll', 'display': 'block' }}>
              <thead>
                <tr>
                  <th className="th-border center" width="5%">Id</th>
                  <th className="th-border left" width="25%">Name</th>
                  <th className="th-border left" width="20%">Specility</th>
                  <th className="th-border left" width="20%">Department</th>
                  <th className="th-border left" width="20%">Registration No</th>
                  <th className="th-border left" width="20%">Specialisation</th>
                  <th className="th-border left" width="20%">Qualification</th>
                  <th className="th-border center" width="10%">Gender</th>
                  <th className="th-border center" width="10%">Experience</th>
                  <th className="th-border right" width="10%">Fees</th>
                  <th className="th-border left" width="10%">Edit</th>
                  <th className="th-border left" width="10%">Delete</th>
                </tr>
              </thead>
              <tbody >
                {
                  (dataStat === true ?
                    (
                      data.map((item, index) =>
                        <tr className="tr-border" key={index}>
                          <td className="center">{item.doctorId}</td>
                          <td className="left">{item.name}</td>
                          <td className="left">{item.specialityName}</td>
                          <td className="left">{item.departmentName}</td>
                          <td className="left">{item.reg_no}</td>
                          <td className="left">{item.specialisation}</td>
                          <td className="left">{item.qualification}</td>
                          <td className="center">{item.gender}</td>
                          <td className="center">{item.yrOfExperience}</td>
                          <td className="right">{item.consultationFees}</td>
                          <td onClick={() => { updateOperation(item.doctorId) }} className="center"><img src={require('./asset/images/adm_edit.png')} alt="" /></td>
                          <td onClick={() => { deleteOperation(item.doctorId) }} className="center"><img src={require('./asset/images/adm_del.png')} alt="" /></td>
                        </tr>
                      ))
                    : <tr><td>No data</td></tr>)
                }
              </tbody>
            </table>
          </div>

          {/* SCREEN FROM ADDING NEW  DOCTOR */}

          <div id="newdept" style={{ 'display': displayDoctor }} className="cont__new-dept">
            <form className="" action="" method="" ref={formRef} >
              <div className="row">
                <div className="c12-l-11"><h3>Add Doctor</h3></div>
                <div className="c12-l-1 center">
                  <p onClick={closeDoctor}><img src={require('./asset/images/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt16">
                <div className="c12-l-12">
                  <div className='row'>
                    <div className="c12-l-4">
                      <p style={{ 'fontSize': '0.85rem' }}>Doctor's Name</p>
                    </div>
                    <div className="c12-l-8">
                      <input type="text" className="box small" autoComplete="off"
                        placeholder="Doctor's Name*" onChange={(e) => setDoctorName(e.target.value)} />
                    </div>
                  </div>
                  <div className='row'>
                    <div className="c12-l-4">
                      <p style={{ 'fontSize': '0.85rem' }}>Registration No</p>
                    </div>
                    <div className="c12-l-8">
                      <input type="text" className="box small" autoComplete="off"
                        placeholder="Doctor's Registation No*" onChange={(e) => setDoctorRegno(e.target.value)} />
                    </div>
                  </div>
                  <div className='row'>
                    <div className="c12-l-4">
                      <p style={{ 'fontSize': '0.85rem' }}>Qualification</p>
                    </div>
                    <div className="c12-l-8">
                      <input type="text" className="box small" autoComplete="off"
                        placeholder="Doctor's Qualification*" onChange={(e) => setDoctorQualification(e.target.value)} />
                    </div>
                  </div>
                  <div className='row'>
                    <div className="c12-l-4">
                      <p style={{ 'fontSize': '0.85rem' }}>Specialisation</p>
                    </div>
                    <div className="c12-l-8">
                      <input type="text" className="box small" autoComplete="off"
                        placeholder="Doctor's Specialisation*" onChange={(e) => setDoctorSpecialisation(e.target.value)} />
                    </div>
                  </div>
                  <div className='row'>
                    <div className="c12-l-4">
                      <p style={{ 'fontSize': '0.85rem' }}>Experience</p>
                    </div>
                    <div className="c12-l-8">
                      <input type="text" className="box small" autoComplete="off"
                        placeholder="Doctor's Experience*" onChange={(e) => setDoctorExperience(e.target.value)} />
                    </div>
                  </div>
                  <div className='row'>
                    <div className="c12-l-4">
                      <p style={{ 'fontSize': '0.85rem' }}>Doctor's Fees</p>
                    </div>
                    <div className="c12-l-8">
                      <input type="text" className="box small" autoComplete="off"
                        placeholder="Doctor's Fees*" onChange={(e) => setDoctorFees(e.target.value)} />
                    </div>
                  </div>
                  <div className='row'>
                    <div className="c12-l-4">
                      <p style={{ 'fontSize': '0.85rem' }}>Gender (M/F)</p>
                    </div>
                    <div className="c12-l-8">
                      <input type="text" className="box small" autoComplete="off"
                        placeholder="Gender(M/F)*" onChange={(e) => setDoctorGender(e.target.value)} />
                    </div>
                  </div>
                  <select className="custom-select" onChange={(e) => getDept(e.target.value)}>
                    <option value='0' >Select Department</option>
                    {
                      (departmentDataStat === true ?
                        (
                          departmentData.map((item3, index) =>
                            <option value={item3.id} >{item3.name}</option>
                          ))
                        : <option value='0' >No Data</option>)
                    }
                  </select>
                  <select className="custom-select" onChange={(e) => setDoctorSpeciality(e.target.value)}>
                    <option value='0' >Select Speciality</option>
                    {
                      (specialityDataStat === true ?
                        (
                          specialityData.map((item2, index) =>
                            <option value={item2.id} >{item2.name}</option>
                          ))
                        : <option value='0' >No Data</option>)
                    }
                  </select>
                  <button disabled={IsDisabled} type="button" onClick={handleSubmit}
                    className="btn solid round">Add Doctors</button>
                  {
                    (isloading === true ?

                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginTop: '5px'
                      }}><Progress /></div>
                      :
                      <div></div>
                    )
                  }
                </div>
              </div>
            </form>
          </div>

          {/* SCREEN FROM UPDTAE EXISTING DOCTOR */}

          <div id="newdept" style={{ 'display': displayUpdDoctor }} className="cont__new-dept">
            <form className="" action="" method="">
              <div className="row">
                <div className="c12-l-11"><h3>Edit Doctors</h3></div>
                <div className="c12-l-1 center">
                  <p onClick={closeUpdDoctor}><img src={require('./asset/images/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt16">
                <div className="c12-l-12">
                  <div className='row'>
                    <div className="c12-l-4">
                      <p style={{ 'fontSize': '0.85rem' }}>Doctor's Name</p>
                    </div>
                    <div className="c12-l-8">
                      <input type="hidden" value={uid} />
                      <input type="text" className="box small"
                        placeholder="Name of the Doctors" onChange={(e) => setDoctorUpdName(e.target.value)}
                        value={updDoctorName} />
                    </div>
                  </div>
                  <div className='row'>
                    <div className="c12-l-4">
                      <p style={{ 'fontSize': '0.85rem' }}>Registration No</p>
                    </div>
                    <div className="c12-l-8">
                      <input type="text" className="box small"
                        placeholder="Registarion No of the Doctors" onChange={(e) => setDoctorUpdRegno(e.target.value)}
                        value={updDoctorRegno} />
                    </div>
                  </div>
                  <div className='row'>
                    <div className="c12-l-4">
                      <p style={{ 'fontSize': '0.85rem' }}>Qualification</p>
                    </div>
                    <div className="c12-l-8">
                      <input type="text" className="box small"
                        placeholder="Qualification of the Doctors" onChange={(e) => setDoctorUpdQualification(e.target.value)}
                        value={updDoctorQualification} />
                    </div>
                  </div>
                  <div className='row'>
                    <div className="c12-l-4">
                      <p style={{ 'fontSize': '0.85rem' }}>Specialisation</p>
                    </div>
                    <div className="c12-l-8">
                      <input type="text" className="box small"
                        placeholder="Specilisation of the Doctors" onChange={(e) => setDoctorUpdSpecialisation(e.target.value)}
                        value={updDoctorSpecialisation} />
                    </div>
                  </div>
                  <div className='row'>
                    <div className="c12-l-4">
                      <p style={{ 'fontSize': '0.85rem' }}>Experience</p>
                    </div>
                    <div className="c12-l-8">
                      <input type="text" className="box small"
                        placeholder="Experience of the Doctors" onChange={(e) => setDoctorUpdExperience(e.target.value)}
                        value={updDoctorExperience} />
                    </div>
                  </div>
                  <div className='row'>
                    <div className="c12-l-4">
                      <p style={{ 'fontSize': '0.85rem' }}>Doctor's Fees</p>
                    </div>
                    <div className="c12-l-8">
                      <input type="text" className="box small"
                        placeholder="Doctor's Fees" onChange={(e) => setDoctorUpdFees(e.target.value)}
                        value={updDoctorFees} />
                    </div>
                  </div>
                  <div className='row'>
                    <div className="c12-l-4">
                      <p style={{ 'fontSize': '0.85rem' }}>Gender (M/F)</p>
                    </div>
                    <div className="c12-l-8">
                      <input type="text" className="box small"
                        placeholder="Gender of the Doctore" onChange={(e) => setDoctorUpdGender(e.target.value)}
                        value={updDoctorGender} />
                    </div>
                  </div>

                  <select className="custom-select" onChange={(e) => getUpdDept(e.target.value)}
                    value={updDoctorDepartment}>
                    {
                      (departmentDataStat === true ?
                        (
                          departmentData.map((item3, index) =>
                            <option value={item3.id} >{item3.name}</option>
                          ))
                        : <tr><td>No data</td></tr>)
                    }
                  </select>

                  <select className="custom-select" onChange={(e) => setDoctorUpdSpeciality(e.target.value)}
                    value={updDoctorSpeciality}>
                    {
                      (specialityDataStat === true ?
                        (
                          specialityData.map((item2, index) =>
                            <option value={item2.id} >{item2.name}</option>
                          ))
                        : <tr><td>No data</td></tr>)
                    }
                  </select>

                  <button onClick={() => { updateDoctor(uid) }} type="button"
                    className="btn solid round">Update Doctor</button>
                  {
                    (isloading === true ?

                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginTop: '5px'
                      }}><Progress /></div>
                      :
                      <div></div>
                    )
                  }
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Doctors;
